
import styled from "styled-components";

const StyledHeading = styled.div``;

export default StyledHeading;